import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useMatch } from 'react-router-dom';

const useOrganisation = (): [string | undefined, Dispatch<SetStateAction<string | undefined>>] => {
  const match = useMatch('/account/:organisation/*');
  const pathOrganisation = match?.params?.organisation;
  const [organisation, setOrganisation] = useState<string | undefined>(pathOrganisation);

  useEffect(() => {
    setOrganisation(pathOrganisation);
  }, [pathOrganisation]);

  return [organisation, setOrganisation];
};

const useOrganisationValue = () => {
  const [organisation] = useOrganisation();

  return organisation;
};

export { useOrganisation, useOrganisationValue };
